import registerI18nTranslations from './registerI18nTranslations';
import registerNumberFormatting from './registerNumberFormatting';
import { RegisterableIntlProvider } from '../../internal/hs-intl';

export default (Provider: RegisterableIntlProvider) => {
  return Promise.all([
    registerI18nTranslations(Provider),
    registerNumberFormatting(Provider),
  ]);
};
